<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Design system components
	import { Button } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let waitForResponse = false;

	const reset = async () => {
		waitForResponse = true;
		const res: SettingRequest = await gen2Request(device, 'service.resetcounters', {
			id: 0,
		});
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Button
	loading={waitForResponse}
	disabled={waitForResponse}
	size="m"
	class="mb-s mt-s"
	variant="primary"
	width="full"
	on:click={reset}
>
	{capFirstChar($format('button_reset', { default: 'reset' }))}
</Button>
